import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import type { Project } from './ProjectModal';
interface ProjectCardProps extends Project {
  fullWidth?: boolean;
  onOpen: (project: Project) => void;
}
export function ProjectCard({
  fullWidth,
  onOpen,
  ...project
}: ProjectCardProps) {
  const {
    t
  } = useLanguage();
  const {
    caseNumber,
    category,
    title,
    description,
    image
  } = project;
  return <div className={`bg-kinetic-card border border-white/[0.08] rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02] hover:brightness-110 ${fullWidth ? 'md:col-span-2' : ''}`} data-id="element-203" data-mp="2gjlrldk99h04">
      <div className="flex items-center justify-between gap-2 px-4 sm:px-6 pt-4 sm:pt-6" data-id="element-204" data-mp="26l5xd1pxlrme">
        <span className="text-xs text-white/30 tracking-widest shrink-0" data-id="element-205" data-mp="2bjh6fa8ejy3k">
          {t.portfolio_case} {caseNumber}
        </span>
        <span className="text-[10px] sm:text-xs text-cyan-400 uppercase tracking-wide text-right truncate" data-id="element-206" data-mp="v8mybm9klofq">
          {category}
        </span>
      </div>

      <button onClick={() => onOpen(project)} aria-label={t.portfolio_cta} className={`relative w-full bg-kinetic-alt mt-3 sm:mt-4 cursor-pointer block ${fullWidth ? 'aspect-[21/9]' : 'aspect-video'}`} data-id="element-207" data-mp="1hnwrm3jp6f4">
        <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" data-id="element-208" data-mp="5i7vgu3roi3d" />

        <span className="corner-bracket top-3 left-3 border-t-2 border-l-2" data-id="element-209" data-mp="5kkjnp04boov" />
        <span className="corner-bracket top-3 right-3 border-t-2 border-r-2" data-id="element-210" data-mp="kdnwjj2rle99" />
        <span className="corner-bracket bottom-3 left-3 border-b-2 border-l-2" data-id="element-211" data-mp="ffmbwtpox6vo" />
        <span className="corner-bracket bottom-3 right-3 border-b-2 border-r-2" data-id="element-212" data-mp="t82a9h7ncgq9" />
      </button>

      <div className="p-4 sm:p-6" data-id="element-213" data-mp="p5ytqe64ely4">
        <h3 className="text-lg sm:text-xl font-bold text-white" data-id="element-214" data-mp="p70g3esl6uv5">{title}</h3>
        <p className="text-sm text-white/50 mt-2 leading-relaxed" data-id="element-215" data-mp="136rqz6nt3v4x">{description}</p>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mt-2 pt-4 px-4 sm:px-6 pb-4 sm:pb-6 border-t border-white/[0.08]" data-id="element-216" data-mp="y7yb57l1rs1l">
        <span className="text-xs text-white/20 font-mono truncate sm:max-w-[140px]" data-id="element-217" data-mp="3w0gjkuevs498">
          {project.slug}
        </span>
        <button onClick={() => onOpen(project)} className="text-xs uppercase tracking-wide transition-colors whitespace-nowrap text-cyan-400 hover:text-cyan-300 cursor-pointer text-left sm:text-right" data-id="element-218" data-mp="4tx9xiks6kci">
          {t.portfolio_cta}
        </button>
      </div>
    </div>;
}